import {
  HOMEPAGE,
  LIBRARY,
  MEDIA_PREFERENCE,
  BRAND_PREFERENCE,
  DEMOGRAPHICS,
  TRENDING,
  ANTICIPATION,
  MEDIA_ACCESS_GROUP,
  BRAND_ACCESS_GROUP,
  DEMO_ACCESS_GROUP,
  TRENDING_ACCESS_GROUP,
  ANTICIPATION_ACCESS_GROUP,
  TRACKER,
  DISCOVER_EXPLORE,
  REDISCOVER,
  CALENDAR,
  AUDIENCE_ACQUISITION,
  SUBSCRIBER_OVERVIEW,
  ACQUISITION_ROLLING,
  ACQUISITION_PREMIERE,
  ATTENTION_INDEX,
  CONTENT_INTELLIGENCE,
  CATALOG_ANALYSIS,
  PERFORMANCE_ANALYSIS,
  BUDGET_SUBSCRIBERS,
  DASHBOARD,
  MEDIA_PLANNING,
  GLOBAL_ATTENTION_INDEX,
  CHAT_BOT,
  TRENDING_TOPICS
} from '../constants/commons'

class EntitlementAccessHelper {
  hasAccess (module, userGroups) {
    switch (module) {
      case MEDIA_PREFERENCE:
        return this.checkAccess(MEDIA_ACCESS_GROUP, userGroups)
      case BRAND_PREFERENCE:
        return this.checkAccess(BRAND_ACCESS_GROUP, userGroups)
      case DEMOGRAPHICS:
        return this.checkAccess(DEMO_ACCESS_GROUP, userGroups)
      case TRENDING:
        return this.checkAccess(TRENDING_ACCESS_GROUP, userGroups)
      case ANTICIPATION:
        return this.checkAccess(ANTICIPATION_ACCESS_GROUP, userGroups)
      default:
        return false
    }
  }

  checkAccess (groups, userGroups) {
    if (userGroups && groups.indexOf(userGroups[0]) > -1) {
      return true
    }
    return false
  }

  getCurrentModule (path) {
    return path.indexOf(HOMEPAGE) > -1 ?
    HOMEPAGE :
    path.indexOf(LIBRARY) > -1 ?
    LIBRARY :
    path.indexOf(TRENDING_TOPICS) > -1 ?
    TRENDING_TOPICS :
    path.indexOf(MEDIA_PREFERENCE) > -1 ?
    MEDIA_PREFERENCE :
    path.indexOf(BRAND_PREFERENCE) > -1 ?
    BRAND_PREFERENCE :
    path.indexOf(DEMOGRAPHICS) > -1 ?
    DEMOGRAPHICS :
    path.indexOf(TRENDING) > -1 ?
    TRENDING :
    path.indexOf(ANTICIPATION) > -1 ?
    ANTICIPATION :
    path.indexOf(TRACKER) > -1 ?
    TRACKER :
    path.indexOf(CALENDAR) > -1 ?
    CALENDAR :
    path.indexOf(REDISCOVER) > -1 ?
    REDISCOVER:
    path.indexOf(DISCOVER_EXPLORE) > -1 ?
    DISCOVER_EXPLORE :
    path.indexOf(ACQUISITION_ROLLING) > -1 ?
    ACQUISITION_ROLLING :
    path.indexOf(ACQUISITION_PREMIERE) > -1 ?
    ACQUISITION_PREMIERE :
    path.indexOf(AUDIENCE_ACQUISITION) > -1 ?
    AUDIENCE_ACQUISITION :
    path.indexOf(SUBSCRIBER_OVERVIEW) > -1 ?
    SUBSCRIBER_OVERVIEW :
    path.indexOf(GLOBAL_ATTENTION_INDEX) > -1 ?
    GLOBAL_ATTENTION_INDEX :
    path.indexOf(ATTENTION_INDEX) > -1 ?
    ATTENTION_INDEX :
    path.indexOf(BUDGET_SUBSCRIBERS) > -1 ?
    BUDGET_SUBSCRIBERS :
    path.indexOf(DASHBOARD) > -1 ?
    DASHBOARD :
    path.indexOf(MEDIA_PLANNING) > -1 ?
    MEDIA_PLANNING :
    path.indexOf(CHAT_BOT) > -1 ?
    CHAT_BOT : ''
  }

  getSelectedNav (path) {
    return path.indexOf(HOMEPAGE) > -1 ?
    CONTENT_INTELLIGENCE :
    path.indexOf(LIBRARY) > -1 ?
    CONTENT_INTELLIGENCE :
    path.indexOf(MEDIA_PREFERENCE) > -1 ?
    CONTENT_INTELLIGENCE :
    path.indexOf(BRAND_PREFERENCE) > -1 ?
    CONTENT_INTELLIGENCE :
    path.indexOf(DEMOGRAPHICS) > -1 ?
    CONTENT_INTELLIGENCE :
    path.indexOf(TRENDING) > -1 ?
    CONTENT_INTELLIGENCE :
    path.indexOf(ANTICIPATION) > -1 ?
    CONTENT_INTELLIGENCE :
    path.indexOf(SUBSCRIBER_OVERVIEW) > -1 ?
    CATALOG_ANALYSIS :
    path.indexOf(REDISCOVER) > -1 ?
    CATALOG_ANALYSIS:
    path.indexOf(DISCOVER_EXPLORE) > -1 ?
    CATALOG_ANALYSIS :
    path.indexOf(TRACKER) > -1 ?
    PERFORMANCE_ANALYSIS :
    path.indexOf(ACQUISITION_ROLLING) > -1 ?
    PERFORMANCE_ANALYSIS :
    path.indexOf(ACQUISITION_PREMIERE) > -1 ?
    PERFORMANCE_ANALYSIS :
    path.indexOf(AUDIENCE_ACQUISITION) > -1 ?
    PERFORMANCE_ANALYSIS :
    path.indexOf(DASHBOARD) > -1 ?
    DASHBOARD :
    path.indexOf(CHAT_BOT) > -1 ?
    CHAT_BOT : ''
  }
}

const instance = new EntitlementAccessHelper()

export default instance
